export const iconFontAwesomeBuildingsToiletsPortable = (
	<i className="fa-solid fa-toilets-portable"></i>
);
